import { API } from '@Providers';

export default async function () {
  const endpoint = '/api/shelter/cart/empty-cart';

  return API({ endpoint });
}
